"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBroker = void 0;
const biometrics_channel_1 = require("./channels/biometrics/biometrics.channel");
const communications_channel_1 = require("./channels/communications/communications.channel");
const crm_channel_1 = require("./channels/crm/crm.channel");
const cross_sell_channel_1 = require("./channels/cross-sell/cross-sell.channel");
const customer_relations_channel_1 = require("./channels/customer-relations/customer-relations.channel");
const geolocation_channel_1 = require("./channels/geolocation/geolocation.channel");
const identity_channel_1 = require("./channels/identity/identity.channel");
const loyalty_indication_channel_1 = require("./channels/loyalty-indication/loyalty-indication.channel");
const mini_cashier_channel_1 = require("./channels/mini-cashier/mini-cashier.channel");
const native_channel_1 = require("./channels/native/native.channel");
const navigation_channel_1 = require("./channels/navigation/navigation.channel");
const notification_channel_1 = require("./channels/notification/notification.channel");
const payments_channel_1 = require("./channels/payments/payments.channel");
const player_channel_1 = require("./channels/player/player.channel");
const post_message_channel_1 = require("./channels/post-message/post-message.channel");
const push_channel_1 = require("./channels/push/push.channel");
const router_channel_1 = require("./channels/router/router.channel");
const session_channel_1 = require("./channels/session-manager/session.channel");
const sport_channel_1 = require("./channels/sport/sport.channel");
const tracking_channel_1 = require("./channels/tracking/tracking.channel");
const ui_channel_1 = require("./channels/ui/ui.channel");
const user_interaction_channel_1 = require("./channels/user-interaction/user-interaction.channel");
const view_injector_channel_1 = require("./channels/view-injector/view-injector.channel");
const wallet_channel_1 = require("./channels/wallet/wallet.channel");
let messageBroker;
class MessageBroker {
    constructor(_logger) {
        this._logger = _logger;
        this.navigation = new navigation_channel_1.NavigationChanel(this._logger);
        this.session = new session_channel_1.SessionChannel(this._logger);
        this.identity = new identity_channel_1.IdentityChannel(this._logger);
        this.customerRelations = new customer_relations_channel_1.CustomerRelationsChannel(this._logger);
        this.crm = new crm_channel_1.CrmChannel(this._logger);
        this.crossSell = new cross_sell_channel_1.CrossSellChannel(this._logger);
        this.communications = new communications_channel_1.CommunicationsChannel(this._logger);
        this.geolocation = new geolocation_channel_1.GeolocationChannel(this._logger);
        this.loyaltyIndication = new loyalty_indication_channel_1.LoyaltyIndicationChannel(this._logger);
        this.miniCashier = new mini_cashier_channel_1.MiniCashierChannel(this._logger);
        this.native = new native_channel_1.NativeChannel(this._logger);
        this.notification = new notification_channel_1.NotificationChannel(this._logger);
        this.payments = new payments_channel_1.PaymentChannel(this._logger);
        this.player = new player_channel_1.PlayerChannel(this._logger);
        this.postMessage = new post_message_channel_1.PostMessageChannel(this._logger);
        this.push = new push_channel_1.PushChannel(this._logger);
        this.router = new router_channel_1.RouterChannel(this._logger);
        this.sport = new sport_channel_1.SportChannel(this._logger);
        this.tracking = new tracking_channel_1.TrackingChannel(this._logger);
        this.ui = new ui_channel_1.UiChannel(this._logger);
        this.userinteraction = new user_interaction_channel_1.UserInteractionChannel(this._logger);
        this.viewInjector = new view_injector_channel_1.ViewInjectorChannel(this._logger);
        this.wallet = new wallet_channel_1.WalletChannel(this._logger);
        this.biometrics = new biometrics_channel_1.BiometricsChannel(this._logger);
    }
}
exports.MessageBroker = MessageBroker;
MessageBroker.init = (logger) => {
    if (messageBroker)
        throw new Error("Message Broker is already exists");
    messageBroker = new MessageBroker(logger);
};
MessageBroker.getInstance = () => {
    return messageBroker;
};
//# sourceMappingURL=message-broker.js.map